/**
 * @since 2026-04-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getConfig } from "./getConfig";

const appConfig = getConfig();
const firebaseConfig = appConfig.auth?.firebase?.config ?? appConfig.FIREBASE_CONFIG;

if (firebaseConfig && appConfig.auth?.firebase?.enabled !== false) {
  const app = initializeApp(firebaseConfig);
  getAuth(app);
}

export { firebaseConfig };
